<template>
  <div class="alphabet-filter" align="center">
    <ul class="team-filter">
      <li
        class="filter-char"
        v-for="(item, index) in charObjs"
        :key="index"
        :class="{ 'filter-char--active': item.active }"
        @click="focusCarousel(item.char, item.active)"
      >
        {{ item.char }}
      </li>
    </ul>
  </div>
</template>

<script>
import store from "@/store/store";
import { mapGetters } from "vuex";
export default {
  data: function() {
    return {
      charObjs: [],
      selectedLetter: ""
    };
  },
  computed: {
    ...mapGetters(["getSelectedTeams"])
  },
  methods: {
    focusCarousel(char, active) {
      if (!active) return;
      this.selectedLetter = char;
      store.commit("setFocusedCharacter", char);
    },
    setActiveCharacters() {
      this.charObjs = [];
      const characters = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"];
      characters.forEach(char => {
        const obj = {
          char,
          active: this.getSelectedTeams.some(
            item => item.name.charAt(0) === char
          )
        };
        this.charObjs.push(obj);
      });
    }
  },
  watch: {
    getSelectedTeams(val) {
      console.log("teams changed", val);
      this.setActiveCharacters();
    }
  },
  mounted() {
    this.setActiveCharacters();
  }
};
</script>
<style lang="scss">
.team-filter {
  border-bottom: 1px solid #ccc;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: var(--pyt-filter-color);
  border-bottom: var(--pyt-filter-border);
  list-style-type: none;
}
.filter-char {
  padding: 5px 10px 5px 10px;
  color: #666;

  &--active {
    color: #ccc;
    cursor: pointer;
  }
}

.filter-char:hover {
  padding: 5px 10px 5px 10px;
  border-top: 1px solid var(--pyt-filter-bg--hover);
  border-bottom: 1px solid var(--pyt-filter-bg--hover);
  color: #fff;
}
</style>
